var React = require('react');

function BeachAccess (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.2475 29.1143L29.1105 26.2523L42.0105 39.1423L39.1505 42.0063L26.2475 29.1143ZM34.8395 17.6643L40.5695 11.9343C32.6695 4.03427 19.8695 4.02427 11.9595 11.9143C19.8295 9.30427 28.5795 11.3943 34.8395 17.6643ZM11.9095 11.9543C4.02946 19.8643 4.02946 32.6643 11.9295 40.5643L17.6595 34.8343C11.3895 28.5843 9.29946 19.8343 11.9095 11.9543ZM11.9495 11.9243C11.9395 11.9343 11.9395 11.9343 11.9295 11.9343C11.9195 11.9443 11.9195 11.9443 11.9195 11.9543C11.1695 17.9743 14.2595 25.7243 20.5295 31.9843L31.9895 20.5243C25.7095 14.2643 17.9695 11.1643 11.9495 11.9243Z","fill":"#D4D4D4"}));
}

BeachAccess.defaultProps = {"width":"48","height":"49","viewBox":"0 0 48 49","fill":"none"};

module.exports = BeachAccess;

BeachAccess.default = BeachAccess;
